import { useTranslation } from "react-i18next";

export const useClientTypeFilterTranslate = () => {
  const { t } = useTranslation();

  return {
    clientTypeLabel: t("clientsPage_filters_clientType_label", {
      defaultValue: "Client type",
    }),
    directClients: t("clientsPage_filters_clientType_direct", {
      defaultValue: "Direct clients",
    }),
    sharedWithSubIB: t("clientsPage_filters_clientType_sharedWithSubIB", {
      defaultValue: "Shared with Sub IB",
    }),
    subIBLabel: t("clientsPage_filters_subIB_label", {
      defaultValue: "Sub IB",
    }),
    subIBHint: t("clientsPage_filters_subIB_hint", {
      defaultValue: "View clients under specific Sub IBs",
    }),
    subIBPlaceholder: t("clientsPage_filters_subIB_placeholder", {
      defaultValue: "All Sub IBs",
    }),
    subIBLoadError: t("clientsPage_filters_subIB_loadError", {
      defaultValue: "We couldn't load your Sub IBs.",
    }),
    retry: t("clientsPage_filters_subIB_retry", {
      defaultValue: "Retry",
    }),
  };
};
